import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M13.382 15.022h-8.26V4.352h4.836v3.427h3.424zM11.03 4.572l2.128 2.124H11.03zm3.337 1.812a.36.36 0 0 1 .095.241v8.464c0 .56-.454 1.014-1.014 1.014h-8.39c-.56 0-1.013-.454-1.013-1.014v-10.8c0-.56.453-1.015 1.014-1.015h6.052c.103 0 .195.043.262.111l.001.001 2.978 2.978.005.005.006.007zM2.413 12.138a.54.54 0 0 1 .54.54l-.001.004a.54.54 0 0 1-.54.537h-.227c-.56 0-1.014-.454-1.014-1.014v-10.8C1.17.844 1.625.39 2.185.39h6.052A.36.36 0 0 1 8.5.501H8.5q.39.392.783.784l-.004.004a.545.545 0 0 1-.008.747.544.544 0 0 1-.77-.005l-.564-.565-5.69.001v10.671h.165",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }